import authService from './auth.service';

export interface SearchClient {
  id: string;
  name: string;
  email: string;
}

export interface SearchCase {
  id: string;
  client_name: string;
  state_slug: string;
  status: string;
}

export interface SearchContract {
  id: string;
  contract_number: string;
  client_name: string;
  status: string;
  client_id: string;
}

export interface SearchCommitment {
  id: string;
  client_name: string;
  product_name: string;
  status: string;
  client_id: string;
}

export interface SearchResults {
  clients: SearchClient[];
  cases: SearchCase[];
  contracts: SearchContract[];
  commitments: SearchCommitment[];
}

const searchService = {
  async globalSearch(q: string): Promise<SearchResults> {
    const { data } = await authService.getApi().get<SearchResults>('/api/v1/search', {
      params: { q },
    });
    return data;
  },
};

export default searchService;
